import { useRef, useCallback } from "react"
import { UploadOptions } from "./photo-uploader/UploadOptions"
import { Preview } from "./photo-uploader/Preview"
import { ACCEPTED_FILE_TYPES } from "@/utils/file.utils"
interface PhotoUploaderProps {
  onPhotoSelect: (file: File) => void
  onPhotoRemove: () => void
  photoPreview: string | null
}

export function PhotoUploader({ onPhotoSelect, onPhotoRemove, photoPreview }: PhotoUploaderProps) {
  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleFileChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (file) {
      onPhotoSelect(file)
    }
    // Reset so the same file can be re-selected after removal
    e.target.value = ""
  }, [onPhotoSelect])

  const handleUploadClick = useCallback(() => {
    fileInputRef.current?.click()
  }, [])

  return (
    <div className="space-y-2">
      <input
        ref={fileInputRef}
        type="file"
        accept={ACCEPTED_FILE_TYPES}
        onChange={handleFileChange}
        className="hidden"
      />

      {photoPreview ? (
        <Preview
          photoPreview={photoPreview}
          onRemove={onPhotoRemove}
        />
      ) : (
        <UploadOptions onUploadClick={handleUploadClick} />
      )}
    </div>
  )
}
